// Base audio context setup that can be used by both visualizer and TTS
export function createBaseAudioContext() {
  return new (window.AudioContext || (window as any).webkitAudioContext)();
}

// Convert base64 to array buffer (used in TTS playback)
export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

// Setup microphone stream with given constraints
export async function setupMicrophoneStream(audioContext: AudioContext) {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ 
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 44100,
      } 
    });
    return audioContext.createMediaStreamSource(stream);
  } catch (error) {
    console.error('Error accessing microphone:', error);
    return null;
  }
}
